module.exports = __webpack_public_path__ + "img/protectus.66b78e6a.png";